
export default function AboutSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              About CPVA
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              <strong>Shared Care. Shared Future.</strong> CPVA bridges pharmacists, veterinarians, patients, and pets to create healthier communities across Canada.
            </p>
            <p className="text-gray-600 mb-6">
              Our association represents the unique intersection of human and animal health, recognizing that the wellbeing of people and their pets is interconnected. We foster collaboration between healthcare professionals to deliver comprehensive, compassionate care.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-user-heart-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900">Patient Care</h3>
                <p className="text-sm text-gray-600">Comprehensive healthcare solutions</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-heart-pulse-line text-2xl text-green-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900">Pet Wellness</h3>
                <p className="text-sm text-gray-600">Advanced veterinary care</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-team-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900">Collaboration</h3>
                <p className="text-sm text-gray-600">Professional partnership</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/ee314d4c5cbe459049be7b192a99e3be.jpg"
              alt="Healthcare professionals working together"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
